module.exports = __webpack_public_path__ + "img/C03TechPVPGiftOfMorrigan_ua.aed46b9c.webp";